import React from 'react'


const IndexSolidBgSection = ({children}) => (
    <div  style={{
        background: `#00549c`,
        margin: '0 -2rem',
        padding: '2rem 4rem',
        color: '#fff'
    }}>
        {children}
    </div>
)

export default IndexSolidBgSection
